/*
 * @Author: your name
 * @Date: 2021-11-08 11:29:24
 * @LastEditTime: 2026-03-18 18:14:01
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \crm-product（西凤产品web）\found\views\sfa\views\reports\display_fees\index.js
 */
/*
 * @Author: your name
 * @Date: 2021-11-08 11:29:24
 * @LastEditTime: 2021-11-08 11:32:13
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \crm-product（西凤产品web）\found\views\sfa\views\reports\display_fees\index.js
 */
import TablePage from '../../../../../components/table_page';
// import DatePicker from '../../../components/datePicker';
// import viewDetail from '../../../components/viewDetail.vue';
import Form from './form/index';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      // formName: 'viewDetail',
    };
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      const {
        code,
      } = val;
      if (code === 'view') {
        this.modalConfig.title = '详情';
        this.formName = 'Form';
        this.formConfig = {
          name: 'CLF',
          code,
          row,
        };
        this.openFull();
      }
    },
  },
  async created() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const executeStartTime = `${year}-${month}-${day} 00:00:00`;
    const executeEndTime = `${year}-${month}-${day} 23:59:59`;
    this.searchFormData = {
      ...this.searchFormData,
      executeStartTime,
      executeEndTime,
    };
    await this.getConfigList('display_fees_report');
    this.formData = {
      ...this.formData,
      executeStartTime,
      executeEndTime,
    };
  },

};
